import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { CKEditorModule } from 'ckeditor4-angular';


import { UpdateViewsPageRoutingModule } from './update-views-routing.module';

import { UpdateViewsPage } from './update-views.page';
import { SharedModule } from '../shared/shared.module';
import { AddUpdateViewsComponent } from './add-update-views/add-update-views.component';
import { UpdateViewsUpdateComponent } from './update-views-update/update-views-update.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CKEditorModule,
    UpdateViewsPageRoutingModule,
    SharedModule,
  ],
  declarations: [
    UpdateViewsPage,
    AddUpdateViewsComponent,
    UpdateViewsUpdateComponent,
  ]
})
export class UpdateViewsPageModule {}
